import { FormEvent, useState } from "react";
import { validateApiKey } from "../lib/api";
import "./ApiKeyPrompt.css";

interface ApiKeyPromptProps {
  onSubmit: (key: string) => void;
}

const ApiKeyPrompt = ({ onSubmit }: ApiKeyPromptProps) => {
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = apiKey.trim();
    if (!trimmed) {
      setError("Please enter a valid API key.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await validateApiKey(trimmed);
      onSubmit(trimmed);
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Failed to validate API key";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="api-key-root">
      <div className="api-key-card">
        <h1>Enter Access Key</h1>
        <p className="api-key-description">
          Paste the API key included in your BillSplit invite link. This keeps the session
          private to people you share the link with.
        </p>
        <form onSubmit={handleSubmit} className="api-key-form">
          <input
            type="password"
            value={apiKey}
            onChange={(event) => setApiKey(event.target.value)}
            placeholder="Paste API key here"
            autoComplete="off"
            disabled={loading}
          />
          {error && <p className="api-key-error">{error}</p>}
          <button type="submit" className="primary" disabled={loading}>
            {loading ? "Checking..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ApiKeyPrompt;
